import { Component } from '@angular/core';
import { EnactIcons } from '@lib-ui/lib/common/types/enactIcons';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { openDialog, openModal } from '@lib-ui/lib/common/utils/openDialog';
import { openNotificationService } from '@lib-ui/lib/atomic/enact-alert-snack-bar/openNotification.service';
import { TimeBasedDischargeGraphComponent } from '@design/containers/graphs/time-based-discharge-graph/time-based-discharge-graph.component';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';



@Component({ standalone: false,
  selector: 'app-test-tools',
  templateUrl: './test-tools.component.html',
  styleUrls: ['./test-tools.component.scss']
})
export class TestToolsComponent {
  favoriteSeason = '';
  seasons: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  checked = true;
  //start slide-toggle & Label
  isSlideChecked = true;
  isSlideChecked2 = true;
  //End slide-toggle & Label

  isShowNotify = true;
  notifyTMsg = 'Tree 1 copied';
  icon2: EnactIcons = "spherical-icon";
  notifyCloseIcon = false;
  notifyCancelBtn = true;
  notifyYesBtn = false;
  selected = false;
  disabled = true;
  helpText = "This is sample help text";
  icon: EnactIcons = "pen-icon";
  btnText = "Free Form";
  isListView = true;

  roofIcon: EnactIcons = "roof";

  value = 25;
  accuracy = 2;
  step = 1;
  title = "Base Height";
  unit = "Feet";

  tileValue = 1.85;
  tileUnit = "kWP";
  tileEntity = "size";


  // Colorpicker
  defaultColor = {
    name: 'Blue',
    value: '#3F7CF6',
  };
  cpPresetLabelName = "Select Color";
  colors = [
    {
      name: 'Sky Blue',
      value: '#4AE5FF',
    },
    {
      name: 'Blue',
      value: '#3F7CF6',
    },
    {
      name: 'Pink',
      value: '#E8007F',
    },
    {
      name: 'Green',
      value: '#00D35E',
    },
  ];
  // ALERT NOTIFICATION
  notfiyIcon: EnactIcons = "notification-icon";
  notifyMsg = this.translateWord('azimuthCanBeBtwnZeroNtxty');
  notifyTimeOut = 100000;
  notifyType = 'danger';
  positionClass = 'toast-bottom-left';
// ALERT NOTIFICATION

  constructor(public dialog: MatDialog,private translate : TranslateService,
    private notificationService: openNotificationService) { }

  openDialogConsumer() {
    const data = { title: this.translateMsg('delApiKey'), message: this.translateMsg('useBlockChnFeat') };
    const dialogRef = openDialog(this.dialog, data);

    dialogRef.afterClosed().pipe(take(1)).subscribe(result => {
      if (result) console.log("YES was clicked");
      else console.log("NO was clicked");

      console.log(result);
    });
  }

  handleValueChange(value: number) {
    console.log(value);
  }

  handleCompositeButtonClick() {
    this.selected = !this.selected;
  }
  translateWord(val: any) {
    let translatedName = ''
    this.translate.get('design.leftPanel.selectedTools.' + val).pipe(take(1)).subscribe(res => {
      translatedName = res;
    })
    return translatedName
  }

  rbtValueChanged(event: any) {
    console.log('valueChanged grop---', event);
  }

  showCustomComponent() {

    const sendNotifyMSG = this.notifyMsg;
    const sendNotifyType = this.notifyType;
    const sendPositionClass = this.positionClass;
    const timeOut = this.notifyTimeOut ? this.notifyTimeOut : 6000;

    this.notificationService.sendMessage({
      message: sendNotifyMSG,
      type: sendNotifyType,
      positionClass: sendPositionClass,
      timeOut:timeOut
    });
  }

  translateMsg(val: any) {
    let translatedName = ''
    this.translate.get('toastrMsgs.' + val).pipe(take(1)).subscribe(res => {
      translatedName = res;
    })
    return translatedName;
  }

}
